import {ComponentRef, Injectable, Injector, ViewContainerRef} from '@angular/core';
import {SuccessComponent} from '../../components/toast/success/success.component';
import {ErrorComponent} from '../../components/toast/error/error.component';
import {WarningComponent} from '../../components/toast/warning/warning.component';
import {InfoComponent} from '../../components/toast/info/info.component';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private toastVcr?: ViewContainerRef;

  constructor(private injector: Injector) {}

  registerViewContainerRef(vcr: ViewContainerRef) {
    this.toastVcr = vcr;
  }

  success(message: string, duration: number = 6000) {
    const vcr = this.ensureVcr();
    const componentRef = vcr.createComponent(SuccessComponent, { injector: this.injector });
    componentRef.setInput('message', message);

    const timeoutId = setTimeout(() => this.removeToast(componentRef), duration);
    const sub = componentRef.instance.onClose.subscribe(() => {
      clearTimeout(timeoutId);
      sub.unsubscribe();
      this.removeToast(componentRef);
    });
  }

  error(message: string, duration: number = 6000) {
    const vcr = this.ensureVcr();
    const componentRef = vcr.createComponent(ErrorComponent, { injector: this.injector });
    componentRef.setInput('message', message);

    const timeoutId = setTimeout(() => this.removeToast(componentRef), duration);
    const sub = componentRef.instance.onClose.subscribe(() => {
      clearTimeout(timeoutId);
      sub.unsubscribe();
      this.removeToast(componentRef);
    });
  }

  warning(message: string, duration: number = 6000) {
    const vcr = this.ensureVcr();
    const componentRef = vcr.createComponent(WarningComponent, { injector: this.injector });
    componentRef.setInput('message', message);

    const timeoutId = setTimeout(() => this.removeToast(componentRef), duration);
    const sub = componentRef.instance.onClose.subscribe(() => {
      clearTimeout(timeoutId);
      sub.unsubscribe();
      this.removeToast(componentRef);
    });
  }

  info(message: string, duration: number = 6000) {
    const vcr = this.ensureVcr();
    const componentRef = vcr.createComponent(InfoComponent, { injector: this.injector });
    componentRef.setInput('message', message);

    const timeoutId = setTimeout(() => this.removeToast(componentRef), duration);
    const sub = componentRef.instance.onClose.subscribe(() => {
      clearTimeout(timeoutId);
      sub.unsubscribe();
      this.removeToast(componentRef);
    });
  }

  private ensureVcr(): ViewContainerRef {
    if (!this.toastVcr) {
      throw new Error('ToastService: call registerViewContainerRef(...) in a root component (e.g., AppComponent).');
    }
    return this.toastVcr;
  }

  private removeToast(componentRef: ComponentRef<unknown>) {
    componentRef.destroy();
  }
}
